import React from "react";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable from "src/components/UI/atoms/ATMTable/ATMTable";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import {
  UserModuleActionTypes,
  UserModuleNameTypes,
} from "src/models/userAccess/UserAccess.model";

type Props = {
  onAddNew: () => void;
  getActionOptions: any;
  columns: any;
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const StudentTestimonialListing = ({
  rows,
  getActionOptions,
  onAddNew,
  columns,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  return (
    <div className="flex flex-col h-full">
      <div className="p-4">
        <ATMPageHeader
          pageTitle="Student Testimonials"
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          hideAddButton={
            !isCheckActionsPermission({
              moduleName: UserModuleNameTypes.TESTIMONIALS,
              actionName: UserModuleActionTypes.ADD,
            })
          }
          buttonProps={{
            btnName: "Add New",
            onClick: onAddNew,
          }}
        />
      </div>
      <div className="flex flex-col flex-1 p-4 pt-0 overflow-auto">
        <ATMTable
          rows={rows}
          columns={columns}
          rowExtraClasses={() => "min-h-[40px]"}
          isLoading={isTableLoading}
        />
      </div>
      <div className="flex justify-end p-4 py-2">
        <ATMPagination
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={setPage}
          onRowsPerPageChange={setRowsPerPage}
          rowCount={totalItems}
          rows={rows}
        />
      </div>
    </div>
  );
};

export default StudentTestimonialListing;
